import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import { EDITOR_ACCENT } from "../editorUiConstants";

const EditorWorkspaceOverlay = ({ onCreateNew, onOpenExisting }) => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      zIndex: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(248, 250, 252, 0.55)",
      backdropFilter: "blur(6px)",
      borderRadius: 2,
    }}
  >
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        p: 4,
        maxWidth: 420,
        textAlign: "center",
        backgroundColor: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 2,
        boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
      }}
    >
      <Typography variant="h6" sx={{ color: EDITOR_ACCENT, fontWeight: 700 }}>
        Crea una nuova email o aprine una esistente.
      </Typography>
      <Stack direction="row" spacing={1.5}>
        <Button startIcon={<AddIcon />} variant="contained" onClick={onCreateNew} sx={{ bgcolor: EDITOR_ACCENT, borderRadius: 0 }}>
          Nuova
        </Button>
        <Button startIcon={<FolderOpenIcon />} variant="outlined" onClick={onOpenExisting} sx={{ borderRadius: 0 }}>
          Apri
        </Button>
      </Stack>
    </Stack>
  </Box>
);

EditorWorkspaceOverlay.propTypes = {
  onCreateNew: PropTypes.func.isRequired,
  onOpenExisting: PropTypes.func.isRequired,
};

export default EditorWorkspaceOverlay;
 